import type { IssueViewFetchOperations } from './IssueViewFetchOperations.tsx';

export const appendOperationQuery = (operation?: IssueViewFetchOperations | string): string =>
	operation ? `?operation=${operation}` : '';
